import React, { Component } from "react";
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import { message } from "antd";
import SymptomOnsetForm from "../ecasBasicDetails/SymptomOnsetForm";

export default class EcasSymptomOnset extends Component {
  constructor(props) {
    super(props);
    this.state = {
      active_step: "1",
    };
  }
  selectUserType = (param) => {
    this.setState({
      active: param,
    });
  };
  continue = () => {
    if (!this.state.active) {
      message.warning("Please select account");
      return;
    }
  };
  onChange = (date, dateString) => {
    this.setState({
      date_of_birth: date,
    });
  };
  set_active_step = (step) => {
    this.setState({ active_step: step });
  };
  render() {
    return (
      <div>
        <Header />
        <div className="main-content demographics-section-wrapper">
          <div className="container">
            <div className="row">
              <div className="col-lg-11 m-auto">
                <div className="demographic-single-section">
                  <a
                    href="/about-me"
                    style={{ width: 95 }}
                    className="back-arrow"
                  >
                    <box-icon
                      name="chevron-left"
                      color="#fff"
                      style={{ position: "relative", top: 1 }}
                    ></box-icon>
                    Back
                  </a>
                  <SymptomOnsetForm
                    set_active_step={this.set_active_step}
                    is_update={true}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}
